import React, { useEffect, useRef, useState } from 'react'
import { EmailFrame } from '../email-composer/components/EmailHtml'

// The email, changing without a flash. An email is a page in a frame, and a
// new page blanks the frame while it loads. So the new one is drawn out of
// sight on top of the old, and faded in once it has loaded and settled; only
// then does the old one go. Quick changes (dragging a colour) only ever
// draw the latest.
const FADE = 160

export const SmoothEmailFrame = ({ html, ...rest }) => {
  const [shown, setShown] = useState({ html, id: 0 })
  const [next, setNext] = useState(null)       // { html, id, ready }
  const id = useRef(0)
  const timer = useRef(null)
  useEffect(() => () => clearTimeout(timer.current), [])

  useEffect(() => {
    if (html === shown.html && !next) return
    if (next && html === next.html) return
    if (html === shown.html) { setNext(null); return }
    clearTimeout(timer.current)
    id.current += 1
    setNext({ html, id: id.current, ready: false })
  }, [html]) // eslint-disable-line react-hooks/exhaustive-deps

  // Loaded: a beat for its fonts, then it fades in, then it replaces the old
  const settled = (n) => {
    clearTimeout(timer.current)
    timer.current = setTimeout(() => {
      setNext((cur) => (cur && cur.id === n.id ? { ...cur, ready: true } : cur))
      timer.current = setTimeout(() => {
        setShown({ html: n.html, id: n.id })
        setNext((cur) => (cur && cur.id === n.id ? null : cur))
      }, FADE + 40)
    }, 90)
  }

  return (
    <div className="sef" style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr)' }}>
      <div key={shown.id} style={{ gridArea: '1 / 1' }}><EmailFrame html={shown.html} {...rest} /></div>
      {next && next.id !== shown.id && (
        <div key={next.id} aria-hidden="true" style={{ gridArea: '1 / 1', opacity: next.ready ? 1 : 0, transition: `opacity ${FADE}ms cubic-bezier(0.32, 0.72, 0, 1)`, pointerEvents: 'none' }}>
          <EmailFrame html={next.html} {...rest} onMeasured={() => { if (!next.ready) settled(next) }} />
        </div>
      )}
    </div>
  )
}

export default SmoothEmailFrame
